import { Switch } from 'react-router-dom';
import {
  CreateTransportRoutePage,
  ListTransportRoutesPage,
  UpdateTransportRoutePage,
} from 'pages/Settings/transport-routes';
import { PrivateRoute } from './PrivateRoute';

const ROOT = '/settings/transport-routes';

export const TRANSPORT_ROUTES = {
  listRoutes: () => ({
    path: `${ROOT}/list` as const,
    permissions: ['listRoutePage'],
  }),
  createRoute: () => ({
    path: `${ROOT}/new` as const,
    permissions: ['newRoutePage'],
  }),
  updateRoute: (id?: string | number) => ({
    path: `${ROOT}/:id` as const,
    url: `${ROOT}/${id}` as const,
    permissions: ['editRoutePage'],
  }),
};

export const TransportRoutes = () => {
  return (
    <Switch>
      <PrivateRoute
        exact
        path={TRANSPORT_ROUTES.createRoute().path}
        hasPermission={TRANSPORT_ROUTES.createRoute().permissions?.[0]}
        component={CreateTransportRoutePage}
      />
      <PrivateRoute
        exact
        path={TRANSPORT_ROUTES.listRoutes().path}
        hasPermission={TRANSPORT_ROUTES.listRoutes().permissions?.[0]}
        component={ListTransportRoutesPage}
      />
      <PrivateRoute
        exact
        path={TRANSPORT_ROUTES.updateRoute().path}
        hasPermission={TRANSPORT_ROUTES.updateRoute().permissions?.[0]}
        component={UpdateTransportRoutePage}
      />
    </Switch>
  );
};